// console.log('Cart drawer contents goes here');


class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.cartDrawerToggles = document.querySelectorAll('.section-header-cart-drawer-toggle');
        this.cartDrawerToggle = this.cartDrawerToggles[0];
        this.cartDrawer = this;
        this.cartDrawerClose = this.querySelector('.cart-drawer-close');
        this.cartDrawerOverlay = this.querySelector('.cart-drawer-overlay');
        this.cartDrawerEmptyRedirect = this.querySelector('.cart-drawer-empty-footer');

        this.setAttribute('tabindex', '-1');

        this.cartDrawerToggles.forEach((toggle) => {
            toggle.addEventListener('click', (event) => this.onClick(event))
        });

        this.cartDrawerClose.addEventListener('click', () => this.close())
        this.cartDrawerClose.addEventListener('keypress', (event) => this.onCloseKeypress(event))
        this.cartDrawerOverlay.addEventListener('click', () => this.close())

        if( this.cartDrawerEmptyRedirect ){
            this.cartDrawerEmptyRedirect.addEventListener('click', () => this.close())
        }

    }

    onClick(event) {

        event.preventDefault();

        this.open()
        // this.cartDrawer.focus();

        setTimeout(() => {
            this.querySelector('a[href]').focus();
        }, 100)
        // document.querySelector('cart-drawer').classList.add('heelo')
    }

    onCloseKeypress(event){
        if (event.key === 'Enter' || event.keyCode === 13) {
            this.cartDrawerToggle.focus();
        }
    }

    open() {
        this.cartDrawer.setAttribute('aria-hidden', 'false');
        this.cartDrawer.classList.add('active');

    }
    close() {
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        this.cartDrawer.classList.remove('active')
    }

}

customElements.define('cart-drawer', CartDrawer);
